import { render, staticRenderFns } from "./vouch.vue?vue&type=template&id=7c8bb370&scoped=true"
import script from "./vouch.vue?vue&type=script&lang=js"
export * from "./vouch.vue?vue&type=script&lang=js"
import style0 from "./vouch.vue?vue&type=style&index=0&id=7c8bb370&prod&lang=less"
import style1 from "./vouch.vue?vue&type=style&index=1&id=7c8bb370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8bb370",
  null
  
)

export default component.exports